/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AcknowledgeCurrentUserPylonPendingMessage200Response,
    AcknowledgeCurrentUserPylonPendingMessage200ResponseFromJSON,
    AcknowledgeCurrentUserPylonPendingMessage200ResponseToJSON,
} from '../models/AcknowledgeCurrentUserPylonPendingMessage200Response';
import {
    type AcknowledgeCurrentUserPylonPendingMessageRequest,
    AcknowledgeCurrentUserPylonPendingMessageRequestFromJSON,
    AcknowledgeCurrentUserPylonPendingMessageRequestToJSON,
} from '../models/AcknowledgeCurrentUserPylonPendingMessageRequest';
import {
    type ApproveUserRequest,
    ApproveUserRequestFromJSON,
    ApproveUserRequestToJSON,
} from '../models/ApproveUserRequest';
import {
    type CreateUserGroup201Response,
    CreateUserGroup201ResponseFromJSON,
    CreateUserGroup201ResponseToJSON,
} from '../models/CreateUserGroup201Response';
import {
    type CreateUserGroupAssignment201Response,
    CreateUserGroupAssignment201ResponseFromJSON,
    CreateUserGroupAssignment201ResponseToJSON,
} from '../models/CreateUserGroupAssignment201Response';
import {
    type FindAllUserDynamicPermissions200Response,
    FindAllUserDynamicPermissions200ResponseFromJSON,
    FindAllUserDynamicPermissions200ResponseToJSON,
} from '../models/FindAllUserDynamicPermissions200Response';
import {
    type FindAllUserFacilityAccess200Response,
    FindAllUserFacilityAccess200ResponseFromJSON,
    FindAllUserFacilityAccess200ResponseToJSON,
} from '../models/FindAllUserFacilityAccess200Response';
import {
    type FindAllUserGroups200Response,
    FindAllUserGroups200ResponseFromJSON,
    FindAllUserGroups200ResponseToJSON,
} from '../models/FindAllUserGroups200Response';
import {
    type FindAllUsersV2200Response,
    FindAllUsersV2200ResponseFromJSON,
    FindAllUsersV2200ResponseToJSON,
} from '../models/FindAllUsersV2200Response';
import {
    type FindOneUser200Response,
    FindOneUser200ResponseFromJSON,
    FindOneUser200ResponseToJSON,
} from '../models/FindOneUser200Response';
import {
    type GetCurrentUser200Response,
    GetCurrentUser200ResponseFromJSON,
    GetCurrentUser200ResponseToJSON,
} from '../models/GetCurrentUser200Response';
import {
    type GetCurrentUserPylonPendingMessage200Response,
    GetCurrentUserPylonPendingMessage200ResponseFromJSON,
    GetCurrentUserPylonPendingMessage200ResponseToJSON,
} from '../models/GetCurrentUserPylonPendingMessage200Response';
import {
    type GetMentionSuggestions200Response,
    GetMentionSuggestions200ResponseFromJSON,
    GetMentionSuggestions200ResponseToJSON,
} from '../models/GetMentionSuggestions200Response';
import {
    type GetOrganizationDynamicPermissions200Response,
    GetOrganizationDynamicPermissions200ResponseFromJSON,
    GetOrganizationDynamicPermissions200ResponseToJSON,
} from '../models/GetOrganizationDynamicPermissions200Response';
import {
    type GetOrganizationMfaSettings200Response,
    GetOrganizationMfaSettings200ResponseFromJSON,
    GetOrganizationMfaSettings200ResponseToJSON,
} from '../models/GetOrganizationMfaSettings200Response';
import {
    type GetOrganizationSsoGroupMappings200Response,
    GetOrganizationSsoGroupMappings200ResponseFromJSON,
    GetOrganizationSsoGroupMappings200ResponseToJSON,
} from '../models/GetOrganizationSsoGroupMappings200Response';
import {
    type RecordMentionUsageRequest,
    RecordMentionUsageRequestFromJSON,
    RecordMentionUsageRequestToJSON,
} from '../models/RecordMentionUsageRequest';
import {
    type SetUserDynamicPermissionsRequest,
    SetUserDynamicPermissionsRequestFromJSON,
    SetUserDynamicPermissionsRequestToJSON,
} from '../models/SetUserDynamicPermissionsRequest';
import {
    type SsoGroupMapping,
    SsoGroupMappingFromJSON,
    SsoGroupMappingToJSON,
} from '../models/SsoGroupMapping';
import {
    type SsoGroupMappingBase,
    SsoGroupMappingBaseFromJSON,
    SsoGroupMappingBaseToJSON,
} from '../models/SsoGroupMappingBase';
import {
    type UpdateCurrentUserHospitalChatSignature200Response,
    UpdateCurrentUserHospitalChatSignature200ResponseFromJSON,
    UpdateCurrentUserHospitalChatSignature200ResponseToJSON,
} from '../models/UpdateCurrentUserHospitalChatSignature200Response';
import {
    type UpdateCurrentUserHospitalChatSignatureRequest,
    UpdateCurrentUserHospitalChatSignatureRequestFromJSON,
    UpdateCurrentUserHospitalChatSignatureRequestToJSON,
} from '../models/UpdateCurrentUserHospitalChatSignatureRequest';
import {
    type UpdateOrganizationMfaSettingsRequest,
    UpdateOrganizationMfaSettingsRequestFromJSON,
    UpdateOrganizationMfaSettingsRequestToJSON,
} from '../models/UpdateOrganizationMfaSettingsRequest';
import {
    type UpdateUserFacilityAccessRequest,
    UpdateUserFacilityAccessRequestFromJSON,
    UpdateUserFacilityAccessRequestToJSON,
} from '../models/UpdateUserFacilityAccessRequest';
import {
    type UserCrmNotificationStatus,
    UserCrmNotificationStatusFromJSON,
    UserCrmNotificationStatusToJSON,
} from '../models/UserCrmNotificationStatus';
import {
    type UserGroup,
    UserGroupFromJSON,
    UserGroupToJSON,
} from '../models/UserGroup';
import {
    type UserGroupAssignment,
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentToJSON,
} from '../models/UserGroupAssignment';

export interface AcknowledgeCurrentUserPylonPendingMessageOperationRequest {
    /**
     * 
     */
    acknowledgeCurrentUserPylonPendingMessageRequest: AcknowledgeCurrentUserPylonPendingMessageRequest;
}

export interface ApproveSsoUserRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    approveUserRequest: ApproveUserRequest;
}

export interface CreateOrganizationSsoGroupMappingRequest {
    /**
     * 
     */
    body: SsoGroupMapping;
}

export interface CreateUserGroupRequest {
    /**
     * 
     */
    userGroup: UserGroup;
}

export interface CreateUserGroupAssignmentRequest {
    /**
     * 
     */
    userGroupAssignment: UserGroupAssignment;
}

export interface DeleteOrganizationSsoGroupMappingRequest {
    /**
     * 
     */
    idpGroupId: string;
}

export interface DeleteUserRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    newTaskUserId?: string;
    /**
     * 
     */
    newProspectUserId?: string;
}

export interface DeleteUserGroupRequest {
    /**
     * 
     */
    id: string;
}

export interface DeleteUserGroupAssignmentRequest {
    /**
     * 
     */
    id: string;
}

export interface FindAllUserDynamicPermissionsRequest {
    /**
     * 
     */
    id: string;
}

export interface FindAllUserFacilityAccessRequest {
    /**
     * 
     */
    id: string;
}

export interface FindAllUserGroupsRequest {
    /**
     * Facility ID
     */
    facilityId?: string;
}

export interface FindAllUsersV2Request {
    /**
     * Page number
     */
    page?: number;
    /**
     * Number of items per page
     */
    limit?: number;
    /**
     * Facility IDs
     */
    facilityIds?: string;
    /**
     * User Type IDs
     */
    userTypeIds?: string;
    /**
     * Search by name
     */
    name?: string;
    /**
     * List of comma separated statuses to filter by status
     */
    statuses?: string;
    /**
     * List of comma separated user IDs to filter by specific users
     */
    userId?: string;
}

export interface FindOneUserRequest {
    /**
     * 
     */
    id: string;
    /**
     * Pass "true" to include soft-deleted users
     */
    includeDeleted?: string;
}

export interface FindOneUserGroupRequest {
    /**
     * 
     */
    id: string;
    /**
     * Facility ID
     */
    facilityId?: string;
}

export interface GetMentionSuggestionsRequest {
    /**
     * 
     */
    facilityId: string;
    /**
     * 
     */
    query?: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
}

export interface RecordMentionUsageOperationRequest {
    /**
     * 
     */
    recordMentionUsageRequest: RecordMentionUsageRequest;
}

export interface RejectSsoUserRequest {
    /**
     * 
     */
    id: string;
}

export interface SetUserDynamicPermissionsOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    setUserDynamicPermissionsRequest: SetUserDynamicPermissionsRequest;
}

export interface UpdateCurrentUserHospitalChatSignatureOperationRequest {
    /**
     * 
     */
    updateCurrentUserHospitalChatSignatureRequest: UpdateCurrentUserHospitalChatSignatureRequest;
}

export interface UpdateOrganizationMfaSettingsOperationRequest {
    /**
     * 
     */
    updateOrganizationMfaSettingsRequest: UpdateOrganizationMfaSettingsRequest;
}

export interface UpdateOrganizationSsoGroupMappingRequest {
    /**
     * 
     */
    idpGroupId: string;
    /**
     * 
     */
    body: SsoGroupMappingBase;
}

export interface UpdateUserCrmNotificationStatusRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    userCrmNotificationStatus: UserCrmNotificationStatus;
}

export interface UpdateUserFacilityAccessOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateUserFacilityAccessRequest: UpdateUserFacilityAccessRequest;
}

export interface UpdateUserGroupRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    userGroup: UserGroup;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for acknowledgeCurrentUserPylonPendingMessage without sending the request
     */
    async acknowledgeCurrentUserPylonPendingMessageRequestOpts(requestParameters: AcknowledgeCurrentUserPylonPendingMessageOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['acknowledgeCurrentUserPylonPendingMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'acknowledgeCurrentUserPylonPendingMessageRequest',
                'Required parameter "acknowledgeCurrentUserPylonPendingMessageRequest" was null or undefined when calling acknowledgeCurrentUserPylonPendingMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/current/pylon-pending-message`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AcknowledgeCurrentUserPylonPendingMessageRequestToJSON(requestParameters['acknowledgeCurrentUserPylonPendingMessageRequest']),
        };
    }

    /**
     * Acknowledge a pending Pylon message so the widget stops auto-opening for it
     */
    async acknowledgeCurrentUserPylonPendingMessageRaw(requestParameters: AcknowledgeCurrentUserPylonPendingMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcknowledgeCurrentUserPylonPendingMessage200Response>> {
        const requestOptions = await this.acknowledgeCurrentUserPylonPendingMessageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcknowledgeCurrentUserPylonPendingMessage200ResponseFromJSON(jsonValue));
    }

    /**
     * Acknowledge a pending Pylon message so the widget stops auto-opening for it
     */
    async acknowledgeCurrentUserPylonPendingMessage(requestParameters: AcknowledgeCurrentUserPylonPendingMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcknowledgeCurrentUserPylonPendingMessage200Response> {
        const response = await this.acknowledgeCurrentUserPylonPendingMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for approveSsoUser without sending the request
     */
    async approveSsoUserRequestOpts(requestParameters: ApproveSsoUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling approveSsoUser().'
            );
        }

        if (requestParameters['approveUserRequest'] == null) {
            throw new runtime.RequiredError(
                'approveUserRequest',
                'Required parameter "approveUserRequest" was null or undefined when calling approveSsoUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/{id}/approve`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveUserRequestToJSON(requestParameters['approveUserRequest']),
        };
    }

    /**
     * Approve SSO user
     */
    async approveSsoUserRaw(requestParameters: ApproveSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.approveSsoUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Approve SSO user
     */
    async approveSsoUser(requestParameters: ApproveSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approveSsoUserRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createOrganizationSsoGroupMapping without sending the request
     */
    async createOrganizationSsoGroupMappingRequestOpts(requestParameters: CreateOrganizationSsoGroupMappingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createOrganizationSsoGroupMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/organizations/sso-group-mappings`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Create an SSO group mapping
     */
    async createOrganizationSsoGroupMappingRaw(requestParameters: CreateOrganizationSsoGroupMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createOrganizationSsoGroupMappingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create an SSO group mapping
     */
    async createOrganizationSsoGroupMapping(requestParameters: CreateOrganizationSsoGroupMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrganizationSsoGroupMappingRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createUserGroup without sending the request
     */
    async createUserGroupRequestOpts(requestParameters: CreateUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroup'] == null) {
            throw new runtime.RequiredError(
                'userGroup',
                'Required parameter "userGroup" was null or undefined when calling createUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user-groups`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupToJSON(requestParameters['userGroup']),
        };
    }

    /**
     * Create a user group
     */
    async createUserGroupRaw(requestParameters: CreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        const requestOptions = await this.createUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a user group
     */
    async createUserGroup(requestParameters: CreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.createUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createUserGroupAssignment without sending the request
     */
    async createUserGroupAssignmentRequestOpts(requestParameters: CreateUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupAssignment'] == null) {
            throw new runtime.RequiredError(
                'userGroupAssignment',
                'Required parameter "userGroupAssignment" was null or undefined when calling createUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user-group-assignments`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupAssignmentToJSON(requestParameters['userGroupAssignment']),
        };
    }

    /**
     * Create a user group assignment
     */
    async createUserGroupAssignmentRaw(requestParameters: CreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroupAssignment201Response>> {
        const requestOptions = await this.createUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroupAssignment201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a user group assignment
     */
    async createUserGroupAssignment(requestParameters: CreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroupAssignment201Response> {
        const response = await this.createUserGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteOrganizationSsoGroupMapping without sending the request
     */
    async deleteOrganizationSsoGroupMappingRequestOpts(requestParameters: DeleteOrganizationSsoGroupMappingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idpGroupId'] == null) {
            throw new runtime.RequiredError(
                'idpGroupId',
                'Required parameter "idpGroupId" was null or undefined when calling deleteOrganizationSsoGroupMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations/sso-group-mappings/{idp_group_id}`;
        urlPath = urlPath.replace('{idp_group_id}', encodeURIComponent(String(requestParameters['idpGroupId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete all mappings for an IdP group
     */
    async deleteOrganizationSsoGroupMappingRaw(requestParameters: DeleteOrganizationSsoGroupMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteOrganizationSsoGroupMappingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all mappings for an IdP group
     */
    async deleteOrganizationSsoGroupMapping(requestParameters: DeleteOrganizationSsoGroupMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganizationSsoGroupMappingRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteUser without sending the request
     */
    async deleteUserRequestOpts(requestParameters: DeleteUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['newTaskUserId'] != null) {
            queryParameters['new_task_user_id'] = requestParameters['newTaskUserId'];
        }

        if (requestParameters['newProspectUserId'] != null) {
            queryParameters['new_prospect_user_id'] = requestParameters['newProspectUserId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a user
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a user
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteUserGroup without sending the request
     */
    async deleteUserGroupRequestOpts(requestParameters: DeleteUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user-groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete user group
     */
    async deleteUserGroupRaw(requestParameters: DeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user group
     */
    async deleteUserGroup(requestParameters: DeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteUserGroupAssignment without sending the request
     */
    async deleteUserGroupAssignmentRequestOpts(requestParameters: DeleteUserGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUserGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user-group-assignments/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete user group assignment
     */
    async deleteUserGroupAssignmentRaw(requestParameters: DeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteUserGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user group assignment
     */
    async deleteUserGroupAssignment(requestParameters: DeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for findAllUserDynamicPermissions without sending the request
     */
    async findAllUserDynamicPermissionsRequestOpts(requestParameters: FindAllUserDynamicPermissionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findAllUserDynamicPermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{id}/dynamic-permissions`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all dynamic permissions for a user
     */
    async findAllUserDynamicPermissionsRaw(requestParameters: FindAllUserDynamicPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserDynamicPermissions200Response>> {
        const requestOptions = await this.findAllUserDynamicPermissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserDynamicPermissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all dynamic permissions for a user
     */
    async findAllUserDynamicPermissions(requestParameters: FindAllUserDynamicPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserDynamicPermissions200Response> {
        const response = await this.findAllUserDynamicPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllUserFacilityAccess without sending the request
     */
    async findAllUserFacilityAccessRequestOpts(requestParameters: FindAllUserFacilityAccessRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findAllUserFacilityAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{id}/facility-access`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all user facility access
     */
    async findAllUserFacilityAccessRaw(requestParameters: FindAllUserFacilityAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserFacilityAccess200Response>> {
        const requestOptions = await this.findAllUserFacilityAccessRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserFacilityAccess200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all user facility access
     */
    async findAllUserFacilityAccess(requestParameters: FindAllUserFacilityAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserFacilityAccess200Response> {
        const response = await this.findAllUserFacilityAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllUserGroups without sending the request
     */
    async findAllUserGroupsRequestOpts(requestParameters: FindAllUserGroupsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user-groups`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find all user groups
     */
    async findAllUserGroupsRaw(requestParameters: FindAllUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserGroups200Response>> {
        const requestOptions = await this.findAllUserGroupsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserGroups200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all user groups
     */
    async findAllUserGroups(requestParameters: FindAllUserGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserGroups200Response> {
        const response = await this.findAllUserGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllUsersV2 without sending the request
     */
    async findAllUsersV2RequestOpts(requestParameters: FindAllUsersV2Request): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['facilityIds'] != null) {
            queryParameters['facility_ids'] = requestParameters['facilityIds'];
        }

        if (requestParameters['userTypeIds'] != null) {
            queryParameters['user_type_ids'] = requestParameters['userTypeIds'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v2/users`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get All Users
     */
    async findAllUsersV2Raw(requestParameters: FindAllUsersV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUsersV2200Response>> {
        const requestOptions = await this.findAllUsersV2RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUsersV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Get All Users
     */
    async findAllUsersV2(requestParameters: FindAllUsersV2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUsersV2200Response> {
        const response = await this.findAllUsersV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneUser without sending the request
     */
    async findOneUserRequestOpts(requestParameters: FindOneUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeDeleted'] != null) {
            queryParameters['include_deleted'] = requestParameters['includeDeleted'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a user by ID
     */
    async findOneUserRaw(requestParameters: FindOneUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneUser200Response>> {
        const requestOptions = await this.findOneUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a user by ID
     */
    async findOneUser(requestParameters: FindOneUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneUser200Response> {
        const response = await this.findOneUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneUserGroup without sending the request
     */
    async findOneUserGroupRequestOpts(requestParameters: FindOneUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findOneUserGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user-groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Find one user group
     */
    async findOneUserGroupRaw(requestParameters: FindOneUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        const requestOptions = await this.findOneUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Find one user group
     */
    async findOneUserGroup(requestParameters: FindOneUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.findOneUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCurrentUser without sending the request
     */
    async getCurrentUserRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/current`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the currently authenticated user
     */
    async getCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentUser200Response>> {
        const requestOptions = await this.getCurrentUserRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the currently authenticated user
     */
    async getCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentUser200Response> {
        const response = await this.getCurrentUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCurrentUserPylonPendingMessage without sending the request
     */
    async getCurrentUserPylonPendingMessageRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/current/pylon-pending-message`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the Pylon chat message the widget should auto-open for, if any
     */
    async getCurrentUserPylonPendingMessageRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentUserPylonPendingMessage200Response>> {
        const requestOptions = await this.getCurrentUserPylonPendingMessageRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentUserPylonPendingMessage200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the Pylon chat message the widget should auto-open for, if any
     */
    async getCurrentUserPylonPendingMessage(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentUserPylonPendingMessage200Response> {
        const response = await this.getCurrentUserPylonPendingMessageRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMentionSuggestions without sending the request
     */
    async getMentionSuggestionsRequestOpts(requestParameters: GetMentionSuggestionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityId'] == null) {
            throw new runtime.RequiredError(
                'facilityId',
                'Required parameter "facilityId" was null or undefined when calling getMentionSuggestions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/mentions/suggestions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get mention suggestions (recent or search)
     */
    async getMentionSuggestionsRaw(requestParameters: GetMentionSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMentionSuggestions200Response>> {
        const requestOptions = await this.getMentionSuggestionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMentionSuggestions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get mention suggestions (recent or search)
     */
    async getMentionSuggestions(requestParameters: GetMentionSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMentionSuggestions200Response> {
        const response = await this.getMentionSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganizationDynamicPermissions without sending the request
     */
    async getOrganizationDynamicPermissionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations/dynamic-permissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all dynamic permissions available in the organization
     */
    async getOrganizationDynamicPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationDynamicPermissions200Response>> {
        const requestOptions = await this.getOrganizationDynamicPermissionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationDynamicPermissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all dynamic permissions available in the organization
     */
    async getOrganizationDynamicPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationDynamicPermissions200Response> {
        const response = await this.getOrganizationDynamicPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganizationMfaSettings without sending the request
     */
    async getOrganizationMfaSettingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations/mfa-settings`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get MFA settings for the current organization
     */
    async getOrganizationMfaSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationMfaSettings200Response>> {
        const requestOptions = await this.getOrganizationMfaSettingsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationMfaSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Get MFA settings for the current organization
     */
    async getOrganizationMfaSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationMfaSettings200Response> {
        const response = await this.getOrganizationMfaSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganizationSsoGroupMappings without sending the request
     */
    async getOrganizationSsoGroupMappingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations/sso-group-mappings`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all SSO group mappings for the current organization
     */
    async getOrganizationSsoGroupMappingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationSsoGroupMappings200Response>> {
        const requestOptions = await this.getOrganizationSsoGroupMappingsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationSsoGroupMappings200ResponseFromJSON(jsonValue));
    }

    /**
     * List all SSO group mappings for the current organization
     */
    async getOrganizationSsoGroupMappings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationSsoGroupMappings200Response> {
        const response = await this.getOrganizationSsoGroupMappingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for recordMentionUsage without sending the request
     */
    async recordMentionUsageRequestOpts(requestParameters: RecordMentionUsageOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['recordMentionUsageRequest'] == null) {
            throw new runtime.RequiredError(
                'recordMentionUsageRequest',
                'Required parameter "recordMentionUsageRequest" was null or undefined when calling recordMentionUsage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/mentions/record`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordMentionUsageRequestToJSON(requestParameters['recordMentionUsageRequest']),
        };
    }

    /**
     * Record a mention usage for recency tracking
     */
    async recordMentionUsageRaw(requestParameters: RecordMentionUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.recordMentionUsageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Record a mention usage for recency tracking
     */
    async recordMentionUsage(requestParameters: RecordMentionUsageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recordMentionUsageRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for rejectSsoUser without sending the request
     */
    async rejectSsoUserRequestOpts(requestParameters: RejectSsoUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling rejectSsoUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{id}/reject`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Reject SSO user
     */
    async rejectSsoUserRaw(requestParameters: RejectSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.rejectSsoUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reject SSO user
     */
    async rejectSsoUser(requestParameters: RejectSsoUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectSsoUserRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for setUserDynamicPermissions without sending the request
     */
    async setUserDynamicPermissionsRequestOpts(requestParameters: SetUserDynamicPermissionsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setUserDynamicPermissions().'
            );
        }

        if (requestParameters['setUserDynamicPermissionsRequest'] == null) {
            throw new runtime.RequiredError(
                'setUserDynamicPermissionsRequest',
                'Required parameter "setUserDynamicPermissionsRequest" was null or undefined when calling setUserDynamicPermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/{id}/dynamic-permissions`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetUserDynamicPermissionsRequestToJSON(requestParameters['setUserDynamicPermissionsRequest']),
        };
    }

    /**
     * Set users dynamic permissions
     */
    async setUserDynamicPermissionsRaw(requestParameters: SetUserDynamicPermissionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setUserDynamicPermissionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set users dynamic permissions
     */
    async setUserDynamicPermissions(requestParameters: SetUserDynamicPermissionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setUserDynamicPermissionsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateCurrentUserHospitalChatSignature without sending the request
     */
    async updateCurrentUserHospitalChatSignatureRequestOpts(requestParameters: UpdateCurrentUserHospitalChatSignatureOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateCurrentUserHospitalChatSignatureRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCurrentUserHospitalChatSignatureRequest',
                'Required parameter "updateCurrentUserHospitalChatSignatureRequest" was null or undefined when calling updateCurrentUserHospitalChatSignature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/current/hospital-chat-signature`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCurrentUserHospitalChatSignatureRequestToJSON(requestParameters['updateCurrentUserHospitalChatSignatureRequest']),
        };
    }

    /**
     * Update current user\'s hospital chat signature
     */
    async updateCurrentUserHospitalChatSignatureRaw(requestParameters: UpdateCurrentUserHospitalChatSignatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCurrentUserHospitalChatSignature200Response>> {
        const requestOptions = await this.updateCurrentUserHospitalChatSignatureRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCurrentUserHospitalChatSignature200ResponseFromJSON(jsonValue));
    }

    /**
     * Update current user\'s hospital chat signature
     */
    async updateCurrentUserHospitalChatSignature(requestParameters: UpdateCurrentUserHospitalChatSignatureOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCurrentUserHospitalChatSignature200Response> {
        const response = await this.updateCurrentUserHospitalChatSignatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateOrganizationMfaSettings without sending the request
     */
    async updateOrganizationMfaSettingsRequestOpts(requestParameters: UpdateOrganizationMfaSettingsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updateOrganizationMfaSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationMfaSettingsRequest',
                'Required parameter "updateOrganizationMfaSettingsRequest" was null or undefined when calling updateOrganizationMfaSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/organizations/mfa-settings`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationMfaSettingsRequestToJSON(requestParameters['updateOrganizationMfaSettingsRequest']),
        };
    }

    /**
     * Update MFA settings for the current organization
     */
    async updateOrganizationMfaSettingsRaw(requestParameters: UpdateOrganizationMfaSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationMfaSettings200Response>> {
        const requestOptions = await this.updateOrganizationMfaSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationMfaSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Update MFA settings for the current organization
     */
    async updateOrganizationMfaSettings(requestParameters: UpdateOrganizationMfaSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationMfaSettings200Response> {
        const response = await this.updateOrganizationMfaSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateOrganizationSsoGroupMapping without sending the request
     */
    async updateOrganizationSsoGroupMappingRequestOpts(requestParameters: UpdateOrganizationSsoGroupMappingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idpGroupId'] == null) {
            throw new runtime.RequiredError(
                'idpGroupId',
                'Required parameter "idpGroupId" was null or undefined when calling updateOrganizationSsoGroupMapping().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateOrganizationSsoGroupMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/organizations/sso-group-mappings/{idp_group_id}`;
        urlPath = urlPath.replace('{idp_group_id}', encodeURIComponent(String(requestParameters['idpGroupId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Replace all mappings for an IdP group
     */
    async updateOrganizationSsoGroupMappingRaw(requestParameters: UpdateOrganizationSsoGroupMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateOrganizationSsoGroupMappingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Replace all mappings for an IdP group
     */
    async updateOrganizationSsoGroupMapping(requestParameters: UpdateOrganizationSsoGroupMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrganizationSsoGroupMappingRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateUserCrmNotificationStatus without sending the request
     */
    async updateUserCrmNotificationStatusRequestOpts(requestParameters: UpdateUserCrmNotificationStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUserCrmNotificationStatus().'
            );
        }

        if (requestParameters['userCrmNotificationStatus'] == null) {
            throw new runtime.RequiredError(
                'userCrmNotificationStatus',
                'Required parameter "userCrmNotificationStatus" was null or undefined when calling updateUserCrmNotificationStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/{id}/crm-notifications`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserCrmNotificationStatusToJSON(requestParameters['userCrmNotificationStatus']),
        };
    }

    /**
     * Update a users crm notification status
     */
    async updateUserCrmNotificationStatusRaw(requestParameters: UpdateUserCrmNotificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateUserCrmNotificationStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a users crm notification status
     */
    async updateUserCrmNotificationStatus(requestParameters: UpdateUserCrmNotificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserCrmNotificationStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateUserFacilityAccess without sending the request
     */
    async updateUserFacilityAccessRequestOpts(requestParameters: UpdateUserFacilityAccessOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUserFacilityAccess().'
            );
        }

        if (requestParameters['updateUserFacilityAccessRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserFacilityAccessRequest',
                'Required parameter "updateUserFacilityAccessRequest" was null or undefined when calling updateUserFacilityAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/{id}/facility-access`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserFacilityAccessRequestToJSON(requestParameters['updateUserFacilityAccessRequest']),
        };
    }

    /**
     * Grant or revoke user access to facilities
     */
    async updateUserFacilityAccessRaw(requestParameters: UpdateUserFacilityAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateUserFacilityAccessRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Grant or revoke user access to facilities
     */
    async updateUserFacilityAccess(requestParameters: UpdateUserFacilityAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserFacilityAccessRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateUserGroup without sending the request
     */
    async updateUserGroupRequestOpts(requestParameters: UpdateUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUserGroup().'
            );
        }

        if (requestParameters['userGroup'] == null) {
            throw new runtime.RequiredError(
                'userGroup',
                'Required parameter "userGroup" was null or undefined when calling updateUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user-groups/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupToJSON(requestParameters['userGroup']),
        };
    }

    /**
     * Update user group
     */
    async updateUserGroupRaw(requestParameters: UpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        const requestOptions = await this.updateUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Update user group
     */
    async updateUserGroup(requestParameters: UpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.updateUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for verifyCurrentUserEmailMfa without sending the request
     */
    async verifyCurrentUserEmailMfaRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/current/email-verification`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Send verification email for the current user
     */
    async verifyCurrentUserEmailMfaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.verifyCurrentUserEmailMfaRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send verification email for the current user
     */
    async verifyCurrentUserEmailMfa(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyCurrentUserEmailMfaRaw(initOverrides);
    }

}
